import { render, staticRenderFns } from "./SentVerificationMail.vue?vue&type=template&id=def16796"
import script from "./SentVerificationMail.vue?vue&type=script&lang=js"
export * from "./SentVerificationMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports